import React from 'react';
import RelativeDate from 'src/components/RelativeDate';

const DateTimeRenderer = ({
  value
}: any) => <RelativeDate datetime={value} />;

export default DateTimeRenderer;
